import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, Typography } from "@mui/material";
import ChargingStationRequest from "components/ChargingStationTable/ChargingStationRequest/ChargingStationRequest";
import DialogApproveCharge from "components/ChargingStationTable/ChargingStationRequest/DialogApproveCharge";
import DialogRequestApprovedCharge from "components/ChargingStationTable/ChargingStationRequest/DialogRequestApprovedCharge";
import DialogRejectApprovedCharge from "components/ChargingStationTable/ChargingStationRequest/DialogRejectApprovedCharge";
import DialogRejectCharge from "components/ChargingStationTable/ChargingStationRequest/DialogRejectCharge";
import { chargingStationApi } from "stores/ChargingStationStore/chargingStationApi";

class ChargingRequestContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      opendistance: false,
      openreject: false,
      open: false,
      openR: false,
      approve_status: true,
      vendor_Id: "",
    };
  }

  componentDidMount() {
    this.props.getChargingStationSeeAllRequest();
  }

  handleDistanceClickOpen = (id, index) => {
    this.setState({ opendistance: true, vendor_Id: id });
  };
  handleRejectClickOpen = (id, index) => {

    this.setState({ openreject: true, vendor_Id: id });
  };

  handleSubmitApproved = async () => {
    let id = this.state.vendor_Id;
    let res = await chargingStationApi.approveRejectApi(id, 1);
    this.setState({ opendistance: false });
    await this.props.getChargingStationSeeAllRequest();

    if (res.status === 1) {
      this.handleClickOpen();
    }
  };
  handleSubmitRejectApproved = async () => {
    let id = this.state.vendor_Id;
    let res = await chargingStationApi.approveRejectApi(id, 0);
    this.setState({ openreject: false });
    await this.props.getChargingStationSeeAllRequest();

    if (res.status === 1) {
      this.handleClickOpenReject();
    }
  };

  handleCloseReject = () => {
    this.setState({ openR: false });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClickOpenReject = () => {
    this.setState({ openR: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleCloseDialogereject = () => {
    this.setState({ openreject: false });
  };

  handleCloseDialoge = () => {
    this.setState({ opendistance: false });
  };
  render() {
    const resdata = this.props?.ChargingStationSeeAllRequestList?.result;

    return (
      <Grid container>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/charging "
            >
              Charging Stations
            </Link>
            <Typography sx={{ fontSize: "14px" }} color=" #0DA861">
              Requests
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <ChargingStationRequest
              data={resdata}
              handleDistanceClickOpen={this.handleDistanceClickOpen}
              handleRejectClickOpen={this.handleRejectClickOpen}
            />
          </Paper>
        </Grid>

        <DialogApproveCharge
          handleSubmitApproved={this.handleSubmitApproved}
          open={this.state.opendistance}
          handleCloseDialoge={this.handleCloseDialoge}
          onClickModel={this.handleClickOpen}
        />
        <DialogRequestApprovedCharge
          handleClose={this.handleClose}
          open={this.state.open}
        />
        <DialogRejectApprovedCharge
          handleClose={this.handleCloseReject}
          open={this.state.openR}
        />
        <DialogRejectCharge
          handleSubmitReject={this.handleSubmitRejectApproved}
          open={this.state.openreject}
          handleCloseDialoge={this.handleCloseDialogereject}
          onClickModel={this.handleClickOpenReject}
        />
      </Grid>
    );
  }
}
export default ChargingRequestContainer;
